module.exports = __webpack_public_path__ + "img/img1.eade4066.jpg";